module.exports = __webpack_public_path__ + "static/img/FJ.63e404e8.png";